import mainNotificationWav from '../Assets/audio/main_notification.wav';

/**
 * Notification sound utility.
 *
 * A single, unified notification sound (main_notification.wav) is used for
 * every in-app alert — chat, batch chat, WhatsApp, class started, enquiries,
 * Zoom chat, etc. The category-specific exports below are kept as thin aliases
 * so existing call sites keep working while all sharing the same sound.
 */

let notificationAudio = null;

/**
 * Play the unified notification sound.
 */
export function playNotificationSound() {
  try {
    if (!notificationAudio) {
      notificationAudio = new Audio(mainNotificationWav);
    }
    notificationAudio.currentTime = 0;
    notificationAudio.volume = 0.5;
    notificationAudio.play().catch(() => {});
  } catch (err) {
    console.warn('[NotifSound] Failed to play notification:', err);
  }
}

// ── Backward-compatible aliases — all notifications share the same sound. ──
export const playClassNotificationSound = playNotificationSound;
export const playEnquiryNotificationSound = playNotificationSound;
export const playChatNotificationSound = playNotificationSound;

/**
 * Request browser notification permission.
 * Returns true if granted.
 */
export async function requestNotificationPermission() {
  if (!('Notification' in window)) return false;
  if (Notification.permission === 'granted') return true;
  if (Notification.permission === 'denied') return false;
  const result = await Notification.requestPermission();
  return result === 'granted';
}

/**
 * Show a browser-level notification.
 */
export function showBrowserNotification(title, options = {}) {
  if (!('Notification' in window) || Notification.permission !== 'granted') return null;
  try {
    const notif = new Notification(title, {
      icon: '/favicon.png',
      badge: '/favicon.png',
      ...options,
    });
    return notif;
  } catch (err) {
    console.warn('[BrowserNotif] Failed:', err);
    return null;
  }
}
